export const sx = {
    title: {
        color: 'inherit',
        fontSize: '11px',
        fontWeight: 'inherit',
        lineHeight: '16.5px',
        textAlign: 'center',
    },
}
